import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PolicySummary } from '../models/common-data-types';

@Injectable({
  providedIn: 'root'
})
export class PortfolioService {

  constructor(private http: HttpClient) { }

  getPortfolio(): Observable<PolicySummary[]> {
    return this.http.get<PolicySummary[]>(`/selfcare/portfolio/policies`);
  }

}
